import './global/underscore'
import { Suspense, StrictMode, version } from 'react'

import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ErrorBoundary } from 'core/errors'

import 'focus-visible'
import 'firacode'
import './index.css'
import App from './core/App'
// @ts-ignore
import * as env from './core/stores/env'
import { ReactDom } from './global'

// @eslint-disable-next-line
;(window as any)._ = _

const fallback = <div>Loading...</div>

const Root = () => (
  <StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={fallback}>
          <App />
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>
)
const log = console.log.bind(console)

log(`starting app with: \n - React ${version}\n - ReactDom ${ReactDom.version}`)

// ReactDom.render(app, rootElement)
createRoot(document.getElementById('root')!).render(<Root />)
